import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "models/role/action";
import { SUBJECT_CUSTOMER } from "models/role/subject";
import { cashManagementRoutes } from "modules/cash-management";
import { checkoutBrandingRoutes } from "modules/checkout";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const AddressEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CustomerManage" */
      "../pages/address/Edit"
    ),
  "CustomerManage"
);

const List = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CustomerList" */
      /* webpackPrefetch: true */
      "../pages/List"
    ),
  "CustomerView"
);

const Edit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CustomerManage" */
      "../pages/Edit"
    ),
  "CustomerManage"
);

const Create = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CustomerManage" */
      "../pages/Create"
    ),
  "CustomerManage"
);

const Details = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CustomerDetails" */
      /* webpackPrefetch: true */
      "../pages/Details"
    ),
  "CustomerDetails"
);

export const customersRoutes: Route = {
  path: PAGE_URLS.list,
  i18nName: "Customers",
  component: List,
  showChildrenInSidebar: false,
  newTheme: true,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CUSTOMER,
  },
  children: [
    {
      i18nName: "Address",
      path: PAGE_URLS.addressEdit,
      newTheme: true,
      component: AddressEdit,
      can: {
        do: ACTION_UPDATE,
        on: SUBJECT_CUSTOMER,
      },
    },
    ...cashManagementRoutes,
    {
      i18nName: "Create customer",
      path: PAGE_URLS.create,
      component: Create,
      newTheme: true,
      can: {
        do: ACTION_CREATE,
        on: SUBJECT_CUSTOMER,
        field: "id",
      },
    },
    {
      i18nName: "Edit customer",
      path: PAGE_URLS.edit,
      component: Edit,
      newTheme: true,
      can: {
        do: ACTION_UPDATE,
        on: SUBJECT_CUSTOMER,
      },
    },
    ...checkoutBrandingRoutes,
    {
      i18nName: "Customer",
      path: PAGE_URLS.details,
      component: Details,
      newTheme: true,
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_CUSTOMER,
      },
      hasNestedSwitch: true,
    },
  ],
};
